import FilterValues from "./filtervalues.js";

class FilterUIHelpers {
    toggleButtonLabel(element) {
        const label = element.innerHTML;
        element.innerHTML = element.getAttribute('data-text');
        element.setAttribute('data-text', label);
    };

    getUpdatedFilterCount(element, count, description) {
        var label = element.innerHTML;
        const index = label.lastIndexOf('(');
        const productLabel = ' products';
        const attribute = 'aria-label';

        if (index !== -1) {
            label = label.slice(0, index);
        }

        element.innerHTML = label + '(' + count + ')';

        if (FilterValues.isRatingId(element.id)) {
            element.setAttribute(attribute, description + ' rating ' + count + productLabel);
        } else {
            element.setAttribute(attribute, label + count + productLabel);
        }
    };
}

export default new FilterUIHelpers();